<template>
  <div class="app" id="app">
    <router-view/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import router from './router/index';

const observer = new MutationObserver(function (mutations) {
  let height = 0;
  for (const mutation of mutations) {
    const target = mutation.target as HTMLUnknownElement;
    if (target.classList.contains('app') || target.style[0] === 'height') {
      const elemToObserve = document.getElementById('app');
      const newHeight = elemToObserve ? elemToObserve.offsetHeight : undefined;
      if (height !== newHeight && newHeight !== undefined) {
        height = newHeight;
        window.parent.postMessage({
          solutoDynamicHtmlInfo: {
            height: newHeight ? newHeight + 'px' : undefined
          }
        }, '*');
      }
    }
  }
});

export default defineComponent({
  created () {
    (window).addEventListener('message', function (evt: MessageEvent) {
      if (evt.data.solutoWeb && evt.data.solutoWeb === 'goBack') {
        router.go(-1);
      }
    });
  },
  data () {
    return {
      height: 0
    };
  },
  mounted () {
    const contentHeight = window.document.getElementById('app')?.offsetHeight + 'px';
    this.observe();
    window.parent.postMessage({
      solutoDynamicHtmlInfo: {
        height: contentHeight
      }
    }, '*');
    window.startBrowser = (url: string) => {
    // From Privacy policy details page, opening the link in external browser is handled by mobile app.
    // <a href="#" onclick="window.startBrowser('https://www.asurion.jp/policy'); return false;">
      window.parent.postMessage({
        onStartBrowser: {
          url
        }
      }, '*');
    };

    window.gotoDetailsFromInjected = () => {
      this.updateIsOpenedFromPP(true);
      const isUq = router.currentRoute.value.path.includes('uq');
      const platform = router.currentRoute.value.path.includes('android') ? 'android' : 'ios';
      router.push(`/${isUq ? 'uq' : 'au'}/privacy-policy/${platform}-details`);
    };
  },
  unmounted () {
    observer.disconnect();
  },
  methods: {
    ...mapActions([
      'updateIsOpenedFromPP'
    ]),
    observe () {
      const elemToObserve = document.getElementById('app');
      if (elemToObserve) {
        observer.observe(elemToObserve, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    }
  }
});
</script>

<style lang="scss">
@import './styles/app.scss';
.app {
  font-family: $font-family;
  color: #535353;
  word-wrap: break-word;
}

.app img,
.app a[href*="#"] {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
}

svg {
  font-family: $font-family !important;
}
p {
  margin-block-start: 0;
  margin-block-end: 0;
}
.with-margin {
  margin-block-start: 24px;
  margin-block-end: 24px;
}
.with-top-margin {
  margin-block-start: 24px;
}
.icon {
  color: #9b9b9b;
  font-size: 24px;
}

</style>
